export const BVTConstants = {

    // User Types
    USER_TYPE_ADMIN: 'ADMIN',
    USER_TYPE_BUSINESS: 'BUSINESS',
    USER_TYPE_AGENT: 'AGENT',
    USER_TYPE_COMPANY: 'COMPANY',

    //Alert Types
    ALERT_TYPE_SUCCESS: 'success',
    ALERT_TYPE_ERROR: 'danger',
    ALERT_TYPE_INPUT: 'warning',

    //Validation
    VALIDATION_TYPE_INVALID: 'invalid',

    //Statuses
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    SUSPENDED: 'SUSPENDED',
    PARENT_INACTIVE: 'PARENT_INACTIVE',
    ARCHIVED: 'ARCHIVED',
    COMPLETED: 'COMPLETED',
    UPCOMING: 'UPCOMING',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING',

    //Workflow types
    WORKFLOW_TYPE_PRIMARY: 'PRIMARY',
    WORKFLOW_TYPE_ADD_ON: 'ADDON',

    //Workflow Action Types
    WORKFLOW_ACTION_TYPE_ASSESSMENT: 'ASSESSMENT',
    WORKFLOW_ACTION_TYPE_PAYMENT: 'PAYMENT',
    WORKFLOW_ACTION_TYPE_CUSTOM: 'CUSTOM',

    //Document Purpose
    AGENT_CERTIFICATE: 'AGENT_CERTIFICATE',
    WORKFLOW_DOCUMENT: 'WORKFLOW_DOCUMENT',
    COMPANY_LOGO: 'COMPANY_LOGO',
    BUSINESS_LOGO: 'BUSINESS_LOGO',

    //File Types
    FILE_TYPES: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
    FILE_SIZE_500_KB_LIMIT: 500 * 1024, // 500 KB in bytes
    FILE_SIZE_1_MB_LIMIT: 1 * 1024 * 1024, // 1 MB in bytes

    //Static Data Types
    COMPANY_CATEGORY: 'COMPANY_CATEGORY',
    COMPANY_REGION: 'COMPANY_REGION',
    COMPANY_SECTOR: 'COMPANY_SECTOR',

    //Payment Types
    PROGRAM_SUBSCRIPTION: 'PROGRAM_SUBSCRIPTION',
    PLATFORM_FEE: 'PLATFORM_FEE',
    WORKFLOW_PAYMENT: 'WORKFLOW_PAYMENT',

    //Business Types
    BUSINESS_TYPE_SOLE_TRADER: 'Sole Trader',
    BUSINESS_TYPE_PARTNERSHIP: 'Partnership',
    BUSINESS_TYPE_COMPANY: 'Company (Pty Ltd)',
    BUSINESS_TYPE_NFP: 'NFP Company (Limited by Guarantee)',
    BUSINESS_TYPE_INCORPORATED_ASSOCIATION: 'Incorporated Association',
    BUSINESS_TYPE_ABORIGINAL_CORPORATION: 'Aboriginal Corporation (under ORIC)',
    BUSINESS_TYPE_COOPERATIVE: 'Cooperative',

    //Business Support Areas
    BUSINESS_SUPPORT_AREA_FINANCE: 'Finance',
    BUSINESS_SUPPORT_AREA_GOVERNANCE: 'Governance and Compliance',
    BUSINESS_SUPPORT_AREA_OPERATIONAL: 'Operational Efficency',
    BUSINESS_SUPPORT_AREA_GROWTH: 'Growth',
    BUSINESS_SUPPORT_AREA_RECOVERY: 'Recovery',
    BUSINESS_SUPPORT_AREA_STARTUP: 'Start Up',
    BUSINESS_SUPPORT_AREA_ESG: 'ESG',
    BUSINESS_SUPPORT_AREA_ORIC: 'ORIC',
    BUSINESS_SUPPORT_AREA_GROWTH: 'Growth',
    BUSINESS_SUPPORT_AREA_OTHER: 'Other',

    //Business Gross Income
    BUSINESS_INCOME_SMALL: "< $100K",
    BUSINESS_INCOME_MEDIUM: "$100K–$5M",
    BUSINESS_INCOME_LARGE: "$5M+",

    //Business Gross Assets
    BUSINESS_ASSET_SMALL: "< $100K",
    BUSINESS_ASSET_MEDIUM: "$100K–$2.5M",
    BUSINESS_ASSET_LARGE: "$2.5M+",

    //Business Employees
    BUSINESS_EMPLOYEE_SMALL: "< 5",
    BUSINESS_EMPLOYEE_MEDIUM: "5–24",
    BUSINESS_EMPLOYEE_LARGE: "25+",

    //Score Ranges
    SCORE_RANGE_POOR: 'Poor',
    SCORE_RANGE_NEED_IMPROVEMENT: 'Need Improvement',
    SCORE_RANGE_STRONG: 'Strong',
    SCORE_RANGE_EXCELLENT: 'Excellent',

    //Phone Number Validation
    PHONE_INPUT_PATTERN: /[^\d\s+]/g, // Pattern to remove non-digit, non-space, non-plus characters
    PHONE_VALIDATION_PATTERN: /^[0-9\s\-\.\(\)\+]+$/, // Pattern to validate phone number format
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 15,
    
    //Session Management
    SESSION_INACTIVITY_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
    SESSION_WARNING_THRESHOLD: 5 * 60 * 1000, // 5 minutes warning before logout
    
    //Heartbeat Configuration
    HEARTBEAT_INTERVAL: 45 * 60 * 1000, // 45 minutes - refresh token before 1-hour expiry
    HEARTBEAT_INITIAL_DELAY: 5 * 60 * 1000, // 5 minutes - initial heartbeat delay
}